import React from "react";

const PrivacyPolicy = () => {
  const contactEmail = "support@numbers.ag";

  return (
    <div
      style={{
        lineHeight: "1.4",
        fontSize: "18px",
        maxWidth: "1400px",
        margin: "0 auto",
        padding: "20px",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          marginBottom: "30px",
        }}
        className="title-cool"
      >
        Privacy Policy
      </h1>

      <p style={{ marginBottom: "15px" }}>
        <strong>Last Updated:</strong> January 16, 2026
      </p>

      <p style={{ marginBottom: "15px" }}>
        Numbers.AG, LLC ("Numbers.AG," "we," "us," or "our") is a United
        States–based Commodity Trading Advisor ("CTA") subject to U.S. federal
        commodities laws, including those enforced by the Commodity Futures
        Trading Commission ("CFTC") and the National Futures Association
        ("NFA"). This policy describes how we collect, protect, and share
        personal information and Nonpublic Personal Information (NPI).
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        1. Information We Collect
      </h2>

      <p style={{ marginBottom: "15px" }}>
        We collect information that identifies, relates to, or could reasonably
        be linked to you.
      </p>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        Information You Provide
      </h3>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          Account details (name, email), subscription/payment data, and content
          submitted to AI tools within Numbers.ag.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        Automatically Collected Information
      </h3>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          IP addresses, browser types, and AI interaction metadata.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        Nonpublic Personal Information (NPI)
      </h3>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          For U.S. consumers, this includes personally identifiable financial
          information provided to obtain a service (e.g., account balances,
          transaction history, or information from a consumer report) that is
          not publicly available.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        2. How We Use and Share Your Information
      </h2>

      <p style={{ marginBottom: "15px" }}>
        We process information to provide our Service, manage billing, and
        comply with U.S. commodities laws.
      </p>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        a. Sharing with Nonaffiliated Third Parties (GLBA/CFTC)
      </h3>
      <p style={{ marginBottom: "15px" }}>
        Under the GLBA and CFTC Part 160, we may share your NPI with
        nonaffiliated third parties only as follows:
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>For Everyday Business Purposes:</strong> To process
          transactions, maintain accounts, or respond to court orders and legal
          investigations.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Service Providers:</strong> To third parties performing
          services on our behalf (e.g., cloud hosting, payment processing)
          under strict confidentiality agreements.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Joint Marketing:</strong> We do not currently share NPI with
          nonaffiliated third parties for joint marketing.
        </li>
      </ul>

      <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
        b. Your Right to Opt Out
      </h3>
      <p style={{ marginBottom: "15px" }}>
        If we ever propose to share your NPI with a nonaffiliated third party
        for purposes other than those listed above (such as for their own
        marketing), we will provide you with a clear and conspicuous Opt-Out
        Notice and a reasonable means to decline such sharing before it occurs.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        3. Lawful Basis for Processing (GDPR)
      </h2>

      <p style={{ marginBottom: "15px" }}>
        For individuals in the EU/EEA, we process data under the following GDPR
        Article 6 bases:
      </p>

      <table
        style={{
          borderCollapse: "collapse",
          marginBottom: "15px",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                textAlign: "left",
                padding: "8px 16px",
                border: "1px solid #000",
                fontWeight: "bold",
              }}
            >
              Purpose
            </th>
            <th
              style={{
                textAlign: "left",
                padding: "8px 16px",
                border: "1px solid #000",
                fontWeight: "bold",
              }}
            >
              Lawful Basis
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Service Delivery &amp; Billing
            </td>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Performance of a Contract (Art. 6(1)(b))
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Support &amp; Security
            </td>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Legitimate Interests (Art. 6(1)(f))
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Compliance with U.S. Laws
            </td>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Legitimate Interests (Art. 6(1)(f))
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Mandatory Record Retention
            </td>
            <td style={{ padding: "8px 16px", border: "1px solid #000" }}>
              Legal Obligation (Art. 6(1)(c))
            </td>
          </tr>
        </tbody>
      </table>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        4. Cookies and Tracking
      </h2>

      <p style={{ marginBottom: "15px" }}>
        We use cookies and similar tracking technologies to:
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          Remember your login preferences
        </li>
        <li style={{ marginBottom: "5px" }}>
          Analyze traffic and user behavior
        </li>
        <li style={{ marginBottom: "5px" }}>Improve site performance</li>
      </ul>

      <p style={{ marginBottom: "15px" }}>
        You can disable cookies through your browser, but some features may not
        function properly.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        5. Initial and Annual Privacy Notices
      </h2>

      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>Initial Notice:</strong> We provide this privacy notice to
          every customer no later than when the customer relationship is
          established.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Annual Notice:</strong> We will provide an annual notice of
          our privacy policy if you maintain a customer relationship with us.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Exception:</strong> We are not required to provide an annual
          notice if we only share NPI under legal exceptions and have not
          changed our sharing policies since our last notice to you.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        6. Data Security and Safeguards
      </h2>

      <p style={{ marginBottom: "15px" }}>
        In accordance with the GLBA Safeguards Rule, we maintain a written
        information security program including:
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>Encryption:</strong> SSL/TLS for data in transit and AES-256
          for data at rest.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Access Controls:</strong> Limiting NPI access to employees
          who need it to provide products or services to you.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>Monitoring:</strong> Regular testing of our security systems
          and vendor risk assessments.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        7. AI Input and Usage
      </h2>

      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          User inputs to the AI are stored for performance and quality
          improvement purposes.
        </li>
        <li style={{ marginBottom: "5px" }}>
          While we may review anonymized logs to improve system accuracy, we do
          not use your data to train third-party models.
        </li>
        <li style={{ marginBottom: "5px" }}>
          Please do not submit personal, financial, or sensitive data into the
          AI unless necessary for your analysis or inquiry.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        8. Data Retention and Regulatory Obligations
      </h2>

      <p style={{ marginBottom: "15px" }}>
        Numbers.AG is required by CFTC Regulation 1.31 and NFA rules to retain
        certain books and records for a minimum of five (5) years.
      </p>
      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>GDPR Notice:</strong> EU/EEA users acknowledge that this
          mandatory U.S. retention period constitutes a valid "Legal Obligation"
          that may limit the Right to Erasure (Art. 17) until the retention
          period expires.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        9. Children's Privacy
      </h2>

      <p style={{ marginBottom: "15px" }}>
        Our Service is not intended for individuals under the age of 18. We do
        not knowingly collect data from minors.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        10. Changes to This Policy
      </h2>

      <p style={{ marginBottom: "15px" }}>
        We may update this Privacy Policy from time to time. Updates will be
        posted on this page with the revised "Last Updated" date. Continued use
        of the Service after such changes constitutes acceptance.
      </p>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        11. Your Rights
      </h2>

      <ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
        <li style={{ marginBottom: "5px" }}>
          <strong>GDPR Rights:</strong> Users in the EU/EEA may request access,
          correction, or restriction of data, subject to the regulatory
          retention limits noted above.
        </li>
        <li style={{ marginBottom: "5px" }}>
          <strong>U.S. Rights:</strong> You may request to review the NPI we
          have collected about you and correct any inaccuracies.
        </li>
      </ul>

      <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>
        12. Contact Information
      </h2>

      <p style={{ marginBottom: "15px" }}>Numbers.AG, LLC</p>
      <p style={{ marginBottom: "15px" }}>
        1200 N Federal Highway, Unit #300, Boca Raton, FL 33433
      </p>
      <p style={{ marginBottom: "15px" }}>
        Email:{" "}
        <a
          href={`mailto:${contactEmail}`}
          style={{ fontWeight: "bold", fontSize: "16px" }}
        >
          {contactEmail}
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
